module.exports = __webpack_public_path__ + "static/img/wx_icon.9a3ff149.png";